import './padStart'

/**
 * Simple file to load polyfills
 */
